import { getAppConfigSingleton } from "@expert/app-config";
import { getAmazonConnectLoginUrl, selectPartnerWithOverride } from "@expert/service-providers";

export function getConnectInstanceDetails({ destinationRelay }: { destinationRelay?: string } = {}) {
    const { amazonConnectInstancesInfo, allowedPartners, getPartnersConfig } = getAppConfigSingleton();
    if (!amazonConnectInstancesInfo) throw new Error("amazonConnectInstancesInfo is not defined");

    const partner = selectPartnerWithOverride(allowedPartners[0]);
    const amazonConnectInstancesInfoConfigKey = getPartnersConfig(partner)?.amazonConnectInstancesInfoConfigKey;

    let connectInstanceInfo = amazonConnectInstancesInfo["others"];
    if (amazonConnectInstancesInfoConfigKey && amazonConnectInstancesInfoConfigKey in amazonConnectInstancesInfo) {
        connectInstanceInfo = amazonConnectInstancesInfo[amazonConnectInstancesInfoConfigKey];
    } else if (partner in amazonConnectInstancesInfo) {
        connectInstanceInfo = amazonConnectInstancesInfo[partner];
    }

    const { instanceAlias, instanceId, region, identityProvider } = connectInstanceInfo;

    const loginUrl =
        identityProvider && getAmazonConnectLoginUrl(identityProvider, region, instanceId, { destinationRelay });
    const ccpUrl = `https://${instanceAlias}.my.connect.aws/connect/ccp-v2`;

    return { loginUrl, ccpUrl, instanceAlias };
}
